import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { ColAction, ListData, PtEntity, RecipientField } from '@pt/pt-models';
import { TranslateService } from '@ngx-translate/core';
import { Recipient } from '@ms-organization-entities';
import { CellClickedEvent, ColDef, GridOptions } from 'ag-grid-community';
import { AgGridTableWrapper } from '../../../utils';
import { ag_grid_frameworkComponents } from '../../../pt-shared.constant';
import { PermissionManager } from '@pt/pt-core';

@Component({
  selector: 'pt-select-recipient-table',
  template: `
    <ag-grid-angular
      *ngIf='gridOptions()'
      class='ag-theme-balham w-100'
      [loadingOverlayComponent]="loadingOverlayComponent"
      [loadingOverlayComponentParams]="loadingOverlayComponentParams"
      [statusBar]="statusBar"
      (filterChanged)="onFilterChanged()"
      [gridOptions]='gridOptions()'
      (columnVisible)='onChangeColumnsVisible($event?.columns)'
      (selectionChanged)='checkBoxChanged()'
      (cellClicked)='cellClicked($event)'
      (gridReady)='onGridReady($event)'
    >
    </ag-grid-angular>
  `,
  styles: [`
    ag-grid-angular {
      height: 322px;
    }
  `]
})
export class SelectRecipientTableComponent extends AgGridTableWrapper<Recipient> implements OnChanges {
  @Input() data: ListData<Recipient> = null;
  @Input() selectedRecipient: Recipient;

  @Output() recipientSelected = new EventEmitter<Recipient>();
  entity: PtEntity = "recipients";

  constructor(public translateService: TranslateService, public permissionManager: PermissionManager) {
    super(translateService, permissionManager);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.onChangeData(changes.data.currentValue);
    }
  }

  cellClicked(row: CellClickedEvent) {
    row.node.setSelected(true);
  }

  createColumnDefs(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      field: RecipientField.name,
      flex: 1,
      resizable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      checkboxSelection: true
    });
    colDef.push({
      field: RecipientField.category,
      flex: 1,
      resizable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true
    });
    colDef.push({
      field: RecipientField.createdAt,
      flex: 1,
      resizable: true,
      cellRenderer: 'dateFormatterRenderer',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true
    });

    return colDef;
  }

  createGridOptions(columnDefs: ColDef[], rowData: Recipient[]): GridOptions {
    return {
      animateRows: false,
      pagination: false,
      rowSelection: 'single',
      rowHeight: 30,
      floatingFiltersHeight: 30,
      defaultColDef: {
        cellStyle: {'line-height': '30px', 'font-size': '12px'}
      },
      rowData,
      columnDefs,
      components: ag_grid_frameworkComponents
    } as GridOptions;
  }

  clickActions(action: ColAction, row: Recipient) {
    return;
  }

  colActionsTemplate(): TemplateRef<unknown> {
    return null;
  }

  checkBoxChanged() {
    this.selectedRecipient = this.gridApi.getSelectedRows()[0];
    this.recipientSelected.emit(this.selectedRecipient);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    // TODO capire cosa fa e se serve @Simone
    if (this.selectedRecipient) {
      this.gridApi.forEachNode(node => {
        if (node.data.id === this.selectedRecipient.id) {
          node.setSelected(true, true);
          this.gridApi.ensureIndexVisible(node.rowIndex);
        }
      });
    }
  }
}
